import { render, staticRenderFns } from "./IconPlayCircle.vue?vue&type=template&id=106152f6"
import script from "./IconPlayCircle.vue?vue&type=script&lang=js"
export * from "./IconPlayCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports